import React, { useState } from 'react';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';
import './MobileKpiTile.css';

/**
 * Native-app StatCard: full-width stacked card — uppercase label + big serif
 * value on the left, trend pill + comparison caption top-right, sub line
 * underneath. Mirrors the RN dashboard's StatCard anatomy/tokens.
 */
export const MobileKpiTile = ({
  label,
  value,
  sub,
  accentColor, // retained for API compatibility; the native card is accent-free
  comparison, // undefined (loading), null (no comparison), or object
  onPress,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const hasComparison = comparison && comparison !== null;
  const isLoading = comparison === undefined;

  const renderTrend = () => {
    if (isLoading) {
      return (
        <div className="mobile-kpi-trend">
          <div className="mobile-kpi-comparison-skeleton" />
        </div>
      );
    }
    if (!hasComparison) return null;

    const { percentChange } = comparison;
    const isPositive = percentChange > 0;
    const isNeutral = percentChange === 0;
    const tone = isNeutral ? 'flat' : isPositive ? 'up' : 'down';
    const Icon = isNeutral ? Minus : isPositive ? ArrowUp : ArrowDown;

    return (
      <div
        className="mobile-kpi-trend"
        onClick={(e) => { e.stopPropagation(); setShowTooltip(true); }}
      >
        <span className={`mobile-kpi-pill mobile-kpi-pill-${tone}`}>
          <Icon size={12} strokeWidth={2.5} />
          {isPositive ? '+' : ''}{percentChange.toFixed(1)}%
        </span>
        {comparison.label && (
          <span className="mobile-kpi-trend-caption">vs {String(comparison.label).replace(/^vs\.?\s+/i, '')}</span>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="mobile-kpi-tile" onClick={onPress}>
        <div className="mobile-kpi-top">
          <div className="mobile-kpi-main">
            <span className="mobile-kpi-label">{label}</span>
            <div className="mobile-kpi-value">{value}</div>
          </div>
          {renderTrend()}
        </div>
        {sub && <div className="mobile-kpi-sub">{sub}</div>}
      </div>

      {/* Comparison detail sheet */}
      {showTooltip && hasComparison && (
        <div className="mobile-tooltip-overlay" onClick={() => setShowTooltip(false)}>
          <div className="mobile-tooltip" onClick={(e) => e.stopPropagation()}>
            <h4>Comparison Details</h4>
            <div className="mobile-tooltip-row">
              <span>Benchmark:</span>
              <span className="mobile-tooltip-value">{comparison.formattedValue || 'N/A'}</span>
            </div>
            <div className="mobile-tooltip-row">
              <span>Change:</span>
              <span
                className={`mobile-tooltip-value ${comparison.percentChange > 0 ? 'is-pos' : comparison.percentChange < 0 ? 'is-neg' : ''}`}
              >
                {comparison.absoluteDelta || 'N/A'}
              </span>
            </div>
            <div className="mobile-tooltip-row">
              <span>% Change:</span>
              <span
                className={`mobile-tooltip-value ${comparison.percentChange > 0 ? 'is-pos' : comparison.percentChange < 0 ? 'is-neg' : ''}`}
              >
                {comparison.percentChange > 0 ? '+' : ''}{comparison.percentChange.toFixed(1)}%
              </span>
            </div>
            <div className="mobile-tooltip-divider" />
            <div className="mobile-tooltip-date">{comparison.dateRange || 'N/A'}</div>
            <button className="mobile-tooltip-close" onClick={() => setShowTooltip(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};
